import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useForgotPasswordForm from './useForgotPasswordForm';

export const ForgotPasswordForm = () => {
  const password = useForgotPasswordForm();
  return (
    <>
      {password.forgotPasswordResult != null && !password.forgotPasswordResult && (
        <div className="alert alert-danger" role="alert">
          There was an error when trying to generate a password reset email. Please contact your
          administrator.
        </div>
      )}
      {password.forgotPasswordResult != null && password.forgotPasswordResult && (
        <div className="alert alert-success" role="alert">
          If a user is associated with the email address provided, an email will be sent with a link
          to reset the password.
        </div>
      )}
      {password.forgotPasswordResult === null && (
        <form onSubmit={(e) => password.handleSubmit(e)}>
          <div className="form-group">
            <label htmlFor="emailAddress">Email Address</label>
            <input
              type="text"
              id="emailAddress"
              className="form-control"
              value={password.emailAddress}
              autoFocus={true}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                password.updateEmailAddress(e.currentTarget.value)
              }></input>
            {password.emailAddress.trim().length > 0 && !password.emailValid && (
              <div className="alert alert-danger">
                <div>Invalid Email</div>
              </div>
            )}
            <div className="d-grid gap-2 mt-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={password.submitDisabled || password.isWorking}>
                Reset Password
                {password.isWorking && <Spinner size="sm" animation="border" className="ms-2" />}
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
};
